import React, { useState, useEffect } from "react";
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Box,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    Stack,
    useThemeProps,
} from "@mui/material";
import Logo from "../../assets/images/common/chat-logo.png";
import { useTheme } from '@mui/material/styles';
import { Myaccount, Mywallet } from '../../icons/icons';
import Link from '@mui/material/Link';
import Autocomplete from '@mui/material/Autocomplete';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from "react-redux";
import { ModelSelection } from "../../redux/chatslice";
import { Logout } from "../../icons/icons";
import { Link as RouterLink } from 'react-router-dom';



function Sidebar({ onPageChange, toggleSidebar }) {
    const theme = useTheme();

    return (
        <>
            
            <Box>
                <Box sx={{
                    p: "28px 0", overflow: "auto",
                }}>
                    {/* <Button type="button" sx={{ p: 0, minWidth: 'auto', height: 'auto', display: { xs: 'block', sm: 'none' }, mr: '10px', position: 'absolute', right: 0, top: 0 }} onClick={toggleSidebar}>
                        X
                    </Button> */}

                    <Box sx={{ p: "14px 24px " }}>
                        <Typography
                            variant="p"
                            sx={{
                                color: theme.palette.disablegrey.gray1,
                                fontSize: "40px",
                                fontWeight: "700",
                                fontSize: "16px",
                            }}
                            fullWidth
                        >
                            Profile
                        </Typography>



                    </Box>

                    <Box
                        component="ul"
                        sx={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                            "& li": {

                                p: "14px 24px ",
                                borderLeft: "4px solid",
                                borderLeftColor: "transparent",
                                cursor: "pointer",
                                overflow: "hidden", // Ensures content doesn't overflow
                                whiteSpace: "nowrap", // Prevents wrapping to a new line
                                textOverflow: "ellipsis",
                                "&:hover": {
                                    color: theme.palette.white.white,
                                    borderLeft: "4px solid",
                                    borderLeftColor: theme.palette.primary.main,
                                    background: theme.palette.primary.light,
                                },
                            },
                        }}
                    >
                        <li onClick={() => onPageChange("account")}>
                            <Stack direction={'row'} alignItems={'center'} spacing={2}>
                                {/* <Box sx={{ mr: '12px' }}> <Myaccount /></Box> */}

                                <Typography
                                    variant="p"
                                    sx={{
                                        color: theme.palette.secondary.main,
                                        fontWeight: "700",
                                        fontSize: "16px",
                                    }}

                                >
                                    My Account
                                </Typography>


                            </Stack>
                        </li>
                        <li onClick={() => onPageChange("wallet")}>
                            <Stack direction={'row'} alignItems={'center'} spacing={2}>
                                {/* <Box sx={{ mr: '12px' }}> <Mywallet /></Box> */}

                                <Typography
                                    variant="p"
                                    sx={{
                                        color: theme.palette.secondary.main,
                                        fontWeight: "700",
                                        fontSize: "16px",
                                    }}

                                >
                                    My Wallet
                                </Typography>


                            </Stack>
                        </li>
                        <li onClick={() => onPageChange("/chat")}>
                            <Stack direction={'row'} alignItems={'center'} spacing={2}>
                                {/* <Box sx={{ mr: '12px' }}> <Mywallet /></Box> */}

                                <Typography
                                    variant="p"
                                    sx={{
                                        color: theme.palette.secondary.main,
                                        fontWeight: "700",
                                        fontSize: "16px",
                                    }}

                                >
                                Chat
                                </Typography>


                            </Stack>
                        </li>
                    </Box>
                </Box>
            </Box>

            <Box
                sx={{
                    p: "24px  22px",
                    borderTop: "1px solid",
                    borderTopColor: theme.palette.border.border1,
                }}
            >
                {/* <Link
                    href="#"
                    sx={{
                        color: theme.palette.secondary.main,
                        fontWeight: "700",
                        fontSize: "16px",
                        display: "inline-flex",
                        alignItems: "center",
                        "&:hover": {
                            textDecoration: "none",
                        },
                    }}
                >
                    {" "}
                    <Box sx={{ mr: "8px" }}>
                        <Logout />
                    </Box>
                    Logout
                </Link> */}
            </Box>
        </>
    );
}

export default Sidebar;
